/**
 * @generated SignedSource<<c39e6876e9ccd2d231f0596eac20bb44>>
 * @relayHash bfc43724fd2fc3a6f132a6d5f7e9da68
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceForgeContextTokenRequestInput = {
  contextIds: ReadonlyArray<string | null | undefined>;
  extensionSpecificContexts: ConfluenceExtensionSpecificContext;
};
export type ConfluenceExtensionSpecificContext = {
  appVersion: string;
  context: ConfluenceForgePayloadContext;
  extensionId: string;
  extensionType?: string | null | undefined;
  installationId?: string | null | undefined;
};
export type ConfluenceForgePayloadContext = {
  appVersion?: string | null | undefined;
  config?: string | null | undefined;
  content?: ConfluenceForgeExtensionDataContent | null | undefined;
  contentId?: string | null | undefined;
  environmentId?: string | null | undefined;
  environmentType?: string | null | undefined;
  extension: ConfluenceForgeExtensionData;
  isConfig?: boolean | null | undefined;
  localId?: string | null | undefined;
  macro?: ConfluenceForgeExtensionDataMacro | null | undefined;
  moduleKey?: string | null | undefined;
  siteUrl?: string | null | undefined;
  space?: ConfluenceForgeExtensionDataSpace | null | undefined;
  spaceKey?: string | null | undefined;
  type?: string | null | undefined;
};
export type ConfluenceForgeExtensionDataContent = {
  id: string;
  status?: string | null | undefined;
  subtype?: string | null | undefined;
  type?: string | null | undefined;
  version?: number | null | undefined;
};
export type ConfluenceForgeExtensionData = {
  autoConvertLink?: string | null | undefined;
  config?: string | null | undefined;
  content?: ConfluenceForgeExtensionDataContent | null | undefined;
  isConfig?: boolean | null | undefined;
  isEditing?: boolean | null | undefined;
  location?: string | null | undefined;
  macro?: ConfluenceForgeExtensionDataMacro | null | undefined;
  references?: ReadonlyArray<string | null | undefined> | null | undefined;
  selectedText?: string | null | undefined;
  space?: ConfluenceForgeExtensionDataSpace | null | undefined;
  template?: ConfluenceForgeExtensionDataTemplate | null | undefined;
  type: string;
};
export type ConfluenceForgeExtensionDataMacro = {
  body?: string | null | undefined;
  isConfiguring?: boolean | null | undefined;
  isInserting?: boolean | null | undefined;
  layout?: string | null | undefined;
};
export type ConfluenceForgeExtensionDataSpace = {
  id?: string | null | undefined;
  key?: string | null | undefined;
};
export type ConfluenceForgeExtensionDataTemplate = {
  id?: string | null | undefined;
};
export type useGetContextTokenMutation$variables = {
  cloudId: string;
  input: ConfluenceForgeContextTokenRequestInput;
};
export type useGetContextTokenMutation$data = {
  readonly confluence_generateForgeContextToken: {
    readonly errors: ReadonlyArray<{
      readonly message: string | null | undefined;
    }> | null | undefined;
    readonly forgeContextToken: {
      readonly expiresAt: string | null | undefined;
      readonly extensionId: string | null | undefined;
      readonly jwt: string | null | undefined;
    } | null | undefined;
    readonly success: boolean;
  } | null | undefined;
};
export type useGetContextTokenMutation = {
  response: useGetContextTokenMutation$data;
  variables: useGetContextTokenMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ConfluenceForgeContextTokenPayload",
    "kind": "LinkedField",
    "name": "confluence_generateForgeContextToken",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "success"
      },
      {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ]
      },
      {
        "concreteType": "ConfluenceForgeContextToken",
        "kind": "LinkedField",
        "name": "forgeContextToken",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "jwt"
          },
          {
            "kind": "ScalarField",
            "name": "expiresAt"
          },
          {
            "kind": "ScalarField",
            "name": "extensionId"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useGetContextTokenMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGetContextTokenMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bfc43724fd2fc3a6f132a6d5f7e9da68",
    "id": "aebc4ac6f19efb4f09e20cf9c09e3afa223b9374353fd6d698d7b653144dd21f",
    "metadata": {},
    "name": "useGetContextTokenMutation",
    "operationKind": "mutation",
    "text": "mutation useGetContextTokenMutation($cloudId:ID!,$input:ConfluenceForgeContextTokenRequestInput!){confluence_generateForgeContextToken(cloudId:$cloudId,input:$input){success,errors{message},forgeContextToken{jwt,expiresAt,extensionId}}}"
  }
};
})();

(node as any).hash = "881cc660c7be5fb9164424934214d110";

export default node;
